import { getHttpApi } from '@cian/http-api/browser';
import {
  fetchDeleteOfferFromFavorites,
  TDeleteOfferFromFavoritesRequest,
  TDeleteOfferFromFavoritesResponse,
} from '../../repositories/favorites/v1/delete-offer-from-favorites';
import {
  TAddFavoriteRequest,
  TAddFavoriteResponse,
  fetchAddFavorite,
} from '../../repositories/favorites/v1/add-favorite';
import { trackingActionAddFromCardJG, trackingActionRemoveFromCardJK } from './tracking';
import { TThunkAction } from '../../types/redux';
import { setIsFavorite } from '../../actions/favorite';

export function removeFavorite(newbuildingId: number, gaLabel: string): TThunkAction {
  return async dispatch => {
    const httpApi = getHttpApi();

    const parameters: TDeleteOfferFromFavoritesRequest = {
      dealType: 'sale',
      entityType: 'newbuilding',
      entityId: newbuildingId,
    };

    const trackActionRemove = trackingActionRemoveFromCardJK(gaLabel, newbuildingId);
    await trackActionRemove();

    const response: TDeleteOfferFromFavoritesResponse = await fetchDeleteOfferFromFavorites({ httpApi, parameters });

    if (response.statusCode === 200) {
      dispatch(setIsFavorite({ isFavorite: false }));
    }
  };
}

export function addFavorite(newbuildingId: number, gaLabel: string): TThunkAction {
  return async dispatch => {
    const httpApi = getHttpApi();
    const parameters: TAddFavoriteRequest = {
      dealType: 'sale',
      entityType: 'newbuilding',
      entityId: newbuildingId,
    };
    const trackActionAdd = trackingActionAddFromCardJG(gaLabel, newbuildingId);
    await trackActionAdd();

    const response: TAddFavoriteResponse = await fetchAddFavorite({ httpApi, parameters });

    if (response.statusCode === 200) {
      dispatch(setIsFavorite({ isFavorite: true }));
    }
  };
}
